import { useCallback, useMemo } from "react";
import { FileFragment } from "gql/graphql";
import ObjectID from "bson-objectid";
import { NEXT_PUBLIC_CLOUDFRONT_URL } from "app/client";
import {
  IFileInTransit,
  FILE_STATE_TYPE,
} from "modules/providers/index-db-provider/index-db-models";
import moment from "moment";
import { getFileExtension } from "modules/utils/Functions";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  file: FileFragment;
  draftId: string;
  isCloseAllModals?: boolean;
}

const useEditImage = ({ file, draftId, isCloseAllModals = false }: IProps) => {
  const { openModal } = useOverlay();

  const fileInTransit: IFileInTransit = useMemo(
    () => ({
      id: new ObjectID().toHexString(),
      updateTime: moment().toISOString(),
      draftId,
      byteCount: file.byteCount,
      uploadedByteCount: file.byteCount,
      percentage: 100,
      name: file.name,
      extension: getFileExtension(file.name),
      stateType: FILE_STATE_TYPE.COMPLETE,
      contentType: file.contentType,
      previewCloudFrontUrl: file.previewCloudFrontUrl,
      isCopied: false,
      isCompressed: false,
      isVoiceNote: false,
      key: file.key,
      previewKey: file.previewKey,
      url: `${NEXT_PUBLIC_CLOUDFRONT_URL}/${file.key}`,
    }),
    [
      draftId,
      file.byteCount,
      file.contentType,
      file.key,
      file.name,
      file.previewCloudFrontUrl,
      file.previewKey,
    ],
  );

  const openEditImageModal = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.EDIT_IMAGE,
        fileInTransit,
        isCloseAllModals,
      });
    },
    [fileInTransit, isCloseAllModals, openModal],
  );

  return {
    openEditImageModal,
  };
};

export default useEditImage;
